function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment, useEffect, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { CSSTransition } from 'react-transition-group';
import { Flex } from '@signicat/designi/components/layout';
import { t } from "../helpers/i18n";
var GlobalStyle = createGlobalStyle(["body{transition:margin 500ms;margin-top:48px;}#signiapp{min-height:calc(100vh - 48px);}"]);
var StyledReadOnlyBanner = styled(Flex).withConfig({
  displayName: "ReadOnlyBanner__StyledReadOnlyBanner",
  componentId: "sc-mb9qrb-0"
})(["padding:12px 24px;position:fixed;z-index:1200;top:-48px;left:0;right:0;min-height:48px;flex-direction:column;justify-content:center;flex-direction:row;align-items:center;background-color:#2A0062;&.trial-banner-enter{top:-48px;}&.trial-banner-enter-active{top:0px;transition:top 400ms;}&.trial-banner-enter-done{top:0px;}&.trial-banner-leave{top:-48px;}&.trial-banner-leave-active{transition:top 400ms;}"]);
var ReadOnlyBanner = function ReadOnlyBanner(props) {
  var children = props.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  useEffect(function () {
    setVisible(true);
    return function () {
      setVisible(false);
    };
  });
  return /*#__PURE__*/React.createElement(CSSTransition, {
    "in": visible,
    classNames: "trial-banner",
    timeout: 400
  }, /*#__PURE__*/React.createElement(StyledReadOnlyBanner, null, /*#__PURE__*/React.createElement(GlobalStyle, null), children ? children : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("p", {
    style: {
      color: '#fff'
    }
  }, t('read_only_mode_dokobit_text') + ' ', /*#__PURE__*/React.createElement("a", {
    style: {
      color: '#fff'
    },
    href: "https://app.dokobit.com/register",
    target: "_blank",
    rel: "noreferrer"
  }, t('dokobit_portal')))))));
};
export default ReadOnlyBanner;